"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateOffer = void 0;
function calculateOffer(calculation, move, configuration) {
    var _a, _b;
    const surcharge = 1 + calculation.relativeSurcharge;
    const loadingAndTransport = round(calculation.staffAndTransportSum * surcharge) -
        calculation.toll +
        round(calculation.insuranceFee * calculation.relativeSurcharge) +
        round(((_a = calculation.deliveryPackingMaterial) !== null && _a !== void 0 ? _a : 0) * surcharge) +
        round(calculation.assemblySum * surcharge);
    const toll = round(calculation.toll, 1);
    const packing = round(calculation.glassPacker.price * surcharge);
    const smallParts = calculation.smallParts;
    const packingMaterial = calculation.packingMaterial.map((p) => ({
        ...p,
        originalPrice: p.price,
        price: round(p.price * surcharge, 2),
    }));
    const noParkingZones = round(calculation.noParkingZones * surcharge -
        move.loadingAddresses
            .filter((address) => address.noParkingZone)
            .reduce((sum, address) => sum + (address.noParkingZoneFees || 0), 0) +
        move.unloadingAddresses
            .filter((address) => address.noParkingZone)
            .reduce((sum, address) => sum + (address.noParkingZoneFees || 0), 0), 1);
    const bulkyWasteDisposal = move.rooms.some((room) => room.items.some((item) => item.disposal))
        ? configuration.calculationParameters.bulkyWasteDisposal
        : 0;
    const storage = round((calculation.storageRent +
        calculation.containerRent +
        calculation.containerHandling +
        calculation.containerTransport) *
        surcharge, 1);
    const other = calculation.otherSum * surcharge;
    const positionsSum = round(round(loadingAndTransport) +
        toll +
        packing +
        smallParts +
        packingMaterial.reduce((sum, material) => sum + material.price, 0) +
        noParkingZones +
        storage +
        other);
    const discount = (_b = move.discount) !== null && _b !== void 0 ? _b : 0;
    const absoluteDiscount = move.discountType === "absolute"
        ? discount
        : (discount * positionsSum) / 100;
    const vatRate = 0.19;
    const totalWithoutDiscount = positionsSum + calculation.insuranceFee;
    const total = totalWithoutDiscount - absoluteDiscount;
    const totalGross = (positionsSum - absoluteDiscount) * (1 + vatRate) +
        calculation.insuranceFee;
    const vat = (positionsSum - absoluteDiscount) * vatRate;
    return {
        positions: {
            loadingAndTransport: round(loadingAndTransport),
            toll,
            packing,
            smallParts,
            packingMaterial,
            noParkingZones,
            storage,
            other,
        },
        positionsSum,
        insuranceFee: calculation.insuranceFee,
        bulkyWasteDisposal,
        totalWithoutDiscount,
        total,
        totalGross,
        vat,
        vatRate,
        absoluteDiscount,
        relativeDiscount: move.discountType === "absolute"
            ? positionsSum === 0
                ? 0
                : discount / positionsSum
            : discount / 100,
    };
}
exports.calculateOffer = calculateOffer;
function round(number, decimals = 2) {
    const factor = Math.pow(10, decimals);
    return Math.round(number * factor) / factor;
}
//# sourceMappingURL=offer.js.map